import type { Axios } from "axios";

export const saveFile = async (
  c: Axios,
  practiceId: string,
  source: string,
  file: File,
): Promise<FileMessage> => {
  const { search } = window.location;
  const formData = new FormData();
  formData.append("file", file);
  formData.append("practice_id", practiceId);
  formData.append("source", source);
  const response = await c.post(`files/${search}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};
